// extracted by mini-css-extract-plugin
export var configurationSection = "_su-0";